import { Layout } from '@/utils/routerHelper'
import { type RouteRecordRaw } from 'vue-router'

/** 热门资讯列表与详情路由。 */
export const hotNewsRouteRecordRaw: RouteRecordRaw[] = [
  {
    path: '/hot-news',
    component: Layout,
    redirect: '/hot-news/list',
    name: 'HotNews',
    meta: {
      title: '资讯列表',
      hidden: true,
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/home/hotNews/list.vue'),
        name: 'HotNewsList',
        meta: {
          title: '资讯列表',
          hidden: true,
        },
      },
      {
        path: 'detail',
        component: () => import('@/views/home/hotNews/detail.vue'),
        name: 'HotNewsDetail',
        meta: {
          title: '资讯详情',
          hidden: true,
        },
      },
    ],
  },
]
